import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Loading = ({ loading }: { loading?: boolean }) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 12 }} spin />;

  return (
    <>
      {loading && <Spin indicator={antIcon} />}
    </>
  );
}

export default Loading;
